import { Action, createReducer, on, } from '@ngrx/store';
import {Course, CourseContent} from '../../services/course-data.service';
import * as actions from './actions';
import {setVideoProgress} from './actions';

// export const userFeatureKey = 'user';

export interface State {
	courses: Course[];
	courseDetails: {[key: string]: Course};
	coursesAreStubbed: boolean;
	currentCourse: string;
	currentLesson: string;
	currentContentItem: CourseContent;
	currentContentType: string;
	coursesProgressTimestamp: number;
	videoProgress: {[key: string]: {position: number, modifiedDate: Date}}; //videoId -> current timestamp
	videoPostTimes: {[key: string]: number};
}

export const initialState: State = {
	courses: [],
	courseDetails: {},
	coursesAreStubbed: true,
	currentCourse: null,
	currentLesson: null,
	currentContentItem: null,
	currentContentType: null,
	coursesProgressTimestamp: 0,
	videoProgress: {},
	videoPostTimes: {},
};

const userReducer = createReducer(
	initialState,
	// on(courseActions.courseListRequested, state => ({...state, courseList: []})),
	on(actions.courseListReceived, (state, action) => ({
		...state,
		coursesAreStubbed: false,
		courses: action.courses,
		courseDetails: {
			...state.courseDetails,
			...action.courses.reduce((agg: any, cur) => {
					agg[cur.url_slug] = cur;
					return agg;
				}, {})
		}
	})),
	on(actions.courseStubListReceived, (state, action) => {
		if (!state.courses.length || state.coursesAreStubbed) return {...state, coursesAreStubbed: true, courses: action.courses};
		return state;
	}),
	on(actions.setCourseDetails, (state, action) => {
		//return the state with the new course info
		return {
			...state,
			courseDetails: {
				...state.courseDetails,
				[action.course.url_slug]: action.course
			},
		};
	}),
	on(actions.setCurrentCourse, (state, action) => ({...state, currentCourse: action.currentCourse})),
	on(actions.setCurrentLesson, (state, action) => ({...state, currentLesson: action.currentLesson})),
	on(actions.setCurrentLessonItem, (state, action) => ({
		...state,
		currentContentItem: action.item,
		currentContentType: action.itemType
	})),

	on(actions.setVideoLastPostTime, (state, action) => ({
		...state,
		videoPostTimes: {
			...state.videoPostTimes,
			[action.videoId]: action.postTime,
		}
	})),
	on(actions.setVideoProgress, (state, action) => ({
		...state,
		videoProgress: {
			...state.videoProgress,
			[action.videoId]: {position: action.progress, modifiedDate: new Date()}
		},
	})),
	on(actions.setVideoProgressList, (state, action) => ({
		...state,
		videoProgress: action.list.reduce((agg, cur) => ({...agg, [cur.videoId]: {position: cur.progress, modifiedDate: cur.modifiedDate}}), {}),
	})),
);

export function reducer(state: State|undefined, action: Action) {
	return userReducer(state, action);
}
